import { AircaftData } from "../../Model/AircraftData";

// Define the initial state for the aircraft reducer
const initialState = {
  aircraftList: [] as AircaftData[],
  loading: false,
  error: null as string | null,
};

// The aircraftReducer function handles actions related to fetching all valid aircraft.
const aircraftReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_ALL_VALID_AIRCRAFT_REQUEST':
      // When a request to fetch aircraft is made, set loading to true and clear any errors
      return { ...state, loading: true, error: null };
    case 'FETCH_ALL_VALID_AIRCRAFT_SUCCESS':
      // When aircraft are successfully fetched, update the aircraftList array and set loading to false
      return { ...state, loading: false, aircraftList: action.payload };
    case 'FETCH_ALL_VALID_AIRCRAFT_FAILURE':
      // When there is an error fetching aircraft, set the error message and set loading to false
      return { ...state, loading: false, error: action.payload };
    default:
      // For any other action types, return the current state
      return state;
  }
};

export default aircraftReducer;